import { TextRegular, TextSemiBold } from 'UiKit/typography';

import styles from './styles.module.css';
import { Condition } from 'Component/others';
import { Box } from '@chakra-ui/react';
import { StrollerIcon } from 'Asset/icon';

const buildTableList = (t) => [
  {
    name: '',
    width: 10,
    key: 'index',
    component: ({ index }) => <TextRegular className={styles['column__text']}>{index + 1}</TextRegular>,
  },
  {
    name: t('tableColumnHostName'),
    width: 300,
    key: 'name',
    component: ({ value }) => (
      <Box className={styles['column__text-name']} style={{ backgroundColor: `${value.hostColor}` }}>
        <TextSemiBold>{value.name}</TextSemiBold>
        <Condition children={<StrollerIcon />} statement={value.isPregnancy} />
      </Box>
    ),
  },
  {
    name: t('totalWorkDays'),
    width: 50,
    key: 'totalWorkDays',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('tableColumnTotalShift', { shift: 1 }),
    width: 50,
    key: 'totalShift1',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('tableColumnTotalShift', { shift: 2 }),
    width: 50,
    key: 'totalShift2',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: t('tableColumnTotalShift', { shift: 3 }),
    width: 50,
    key: 'totalShift3',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
];

export default buildTableList;
